import { IPaidPackage } from '@ucheba/store/institutions/item/types'

export const isPaidPackage = (paidPackage: IPaidPackage | null): boolean => {
  return !!(paidPackage && paidPackage.id !== 17)
}
